//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { FORM_FIELD_TYPES } from '@/constants/form';
import InputField from '@/components/form/InputField';
import ConstructorField from '@/components/ApplicationForm/ConstructorField';
import SelectField from '@/components/form/SelectField';

export default {
    components: { SelectField, ConstructorField, InputField },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        // eslint-disable-next-line vue/prop-name-casing
        value: {
            type: [Object],
            required: true
        },
        fields: { type: Array, required: true },
        errors: { type: Object, required: true }
    },
    computed: {
        modelValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('change', val);
            }
        },
        FIELD_TYPES() {
            return FORM_FIELD_TYPES;
        },
        isFieldsExists() {
            return this.fields?.length > 0;
        }
    },
    methods: {
        getMaskType(validationType) {
            let maskType = '';
            if (validationType === 'ru_phone') {
                maskType = 'phone';
            }

            return maskType;
        }
    }
};
